import { render, staticRenderFns } from "./ChecklistQuestion.vue?vue&type=template&id=947d6d64"
import script from "./ChecklistQuestion.vue?vue&type=script&lang=js"
export * from "./ChecklistQuestion.vue?vue&type=script&lang=js"
import style0 from "./ChecklistQuestion.vue?vue&type=style&index=0&id=947d6d64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports